export default class Items {

    constructor(items) {
        this.allItems = items
    }

    applyPromoCode(code, userdata) {
        if (!code) return;
        if (!userdata) return;
        if (!userdata.items) userdata.items = [];

        //apply code and save as item
        //check if is a code
        var promoCodeItem = this.allItems.find(function (item) {
            if (item.type !== "PromoCode") return false;
            return item.name.toUpperCase() === code.toUpperCase();
        });
        if (!promoCodeItem) {
            const error = { error: true, message: "Code not valid" };
            return error;
        }

        //check if already have it (item)
        if (userdata.items.indexOf(promoCodeItem.name) !== -1) {
            const error = { error: true, message: "This code has already been redeemed" };
            return error;
        }

        //apply coin reward
        if (promoCodeItem.coins) {
            userdata.coins = (userdata.coins || 0) + promoCodeItem.coins;
        }
        //apply no ads
        if (promoCodeItem.item === "NoAds") {
            userdata.removeAds = true;
        }
        //add item
        if (promoCodeItem.item) {
            userdata.items.push(promoCodeItem.item);
        }

        //save promocode to items
        userdata.items.push(promoCodeItem.name);

        return promoCodeItem; //"You have redeemed: " + promoCodeItem.description;
    }
    getItem(itemName) {
        var item = this.allItems.find(function (item) { return item.name === itemName; });
        return item || null;
    };
    getRandomAvatar() {
        let items = this.allItems.filter(i => i.type === "Avatar");
        let item = items[Math.floor(Math.random() * items.length)];
        return item ? item.url : null;
    }
  
}
